var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.imageType,{tag:"component",staticClass:"cwp-icon",class:_vm.classes,attrs:{"src":_vm.imageSrc,"width":"100%"},on:{"click":function($event){return _vm.$emit('click')},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }